export default __webpack_public_path__ + "static/media/k4.a5cc64ef.jpg";